(function () {
  if (window.__u4Rewards) return;
  window.__u4Rewards = true;
  window.__u4RewardsBusy = false;
  window.__u4RewardsFailed = {};

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function qualifying(cart) {
    var sum = 0;
    (cart.items || []).forEach(function (it) {
      var fg = it.properties && it.properties._free_gift;
      if (!fg) sum += it.final_line_price;
    });
    return sum;
  }

  // generic: read a duration CSS var (e.g. "0.7s" / "400ms") off the cart-items container as ms
  function cssMs(varName, fallback) {
    var host = document.querySelector('.cart-drawer__inner .cart-items') || document.querySelector('.cart-items');
    var v = host ? getComputedStyle(host).getPropertyValue(varName).trim() : '';
    if (!v) return fallback;
    if (v.indexOf('ms') > -1) return parseFloat(v) || fallback;
    return Math.round((parseFloat(v) || (fallback / 1000)) * 1000);
  }
  // group open/close speed
  function getSpeedMs() { return cssMs('--u4-grp-spd', 400); }
  // dedicated gift-section reveal/hide speed (merchant-controlled)
  function getGiftRevMs() { return cssMs('--u4-giftrev-spd', 700); }

  function getSid() {
    var cc = document.querySelector('cart-items-component[data-section-id]');
    return cc ? cc.getAttribute('data-section-id') : null;
  }

  // Apply a rendered section HTML string to the live cart drawer.
  function applySectionHtml(html) {
    if (!html) return false;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('.cart-drawer__inner');
    var cur = document.querySelector('.cart-drawer__inner');
    if (fresh && cur) {
      cur.innerHTML = fresh.innerHTML;
      // Re-apply grouping SYNCHRONOUSLY (same tick, before the browser paints) so the group headers
      // don't vanish on morph and then pop back in ~120ms later (the flicker). One coherent frame.
      try { if (window.__u4Group) window.__u4Group(); } catch (e) {}
      return true;
    }
    return false;
  }

  // SINGLE GET fallback used only to fix DOM drift when no cart mutation happened.
  // (We do NOT hammer this endpoint — rapid repeated GETs to ?sections= get rate-limited
  // and start returning EMPTY html. Max 2 gentle attempts.)
  async function fetchSectionOnce(sid, expectedGiftCount) {
    if (!sid) return null;
    for (var attempt = 0; attempt < 2; attempt++) {
      try {
        var bust = '&u4ts=' + ((window.performance ? Math.round(performance.now()) : 0) + '_' + attempt);
        var resp = await fetch(location.pathname + '?sections=' + encodeURIComponent(sid) + bust, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        var data = await resp.json();
        var html = data && data[sid];
        if (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var rg = tmp.querySelectorAll('.cart-items__table-row--free-gift').length;
          if (expectedGiftCount == null || rg === expectedGiftCount) return html;
        }
      } catch (e) { /* retry once */ }
      await sleep(600);
    }
    return null;
  }

  /* ---------- celebration effects ---------- */
  function reduceMotion() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function celebrate(fx) {
    if (!fx || fx === 'none') return;
    var host = document.querySelector('.cart-drawer__dialog') || document.querySelector('.cart-drawer__inner');
    if (!host) return;
    if (fx === 'glow') {
      var fill = document.querySelector('cart-rewards .u4r-line-fill');
      if (fill) { fill.classList.remove('u4r-glow-flash'); void fill.offsetWidth; fill.classList.add('u4r-glow-flash'); }
      return;
    }
    if (reduceMotion()) return;
    var layer = document.createElement('div');
    layer.className = 'u4r-fx-layer';
    host.appendChild(layer);
    var n, makeEl;
    var colors = ['#1a7f37', '#22c55e', '#ffd166', '#ffb703', '#ef476f', '#ff5d8f', '#118ab2', '#3a86ff', '#8338ec', '#06d6a0', '#ffffff'];
    // confetti motion style + speed (merchant-selectable via cart-rewards data attrs)
    var crEl = document.querySelector('cart-rewards');
    var confMotion = (crEl && crEl.getAttribute('data-confetti-motion')) || 'flutter';
    var confSpeed = parseFloat(crEl && crEl.getAttribute('data-confetti-speed')) || 1;
    var motionDurF = ({ flutter: 1, soft: 1.05, drift: 1.25, rain: 0.68 })[confMotion] || 1;
    var motionDxR = confMotion === 'drift' ? 210 : (confMotion === 'rain' ? 38 : 110);
    if (fx === 'confetti') {
      n = 60;
      makeEl = function (i) {
        var p = document.createElement('span');
        p.className = 'u4r-fx-piece u4r-fx-confetti' + (confMotion !== 'flutter' ? ' m-' + confMotion : '');
        p.style.background = colors[(Math.random() * colors.length) | 0];
        var k = Math.random();
        if (k < 0.16) {                 // thin streamer
          var w1 = 3 + Math.round(Math.random() * 2);
          p.style.width = w1 + 'px';
          p.style.height = (16 + Math.round(Math.random() * 16)) + 'px';
          p.style.borderRadius = '3px';
        } else if (k < 0.5) {           // round dot
          var w2 = 6 + Math.round(Math.random() * 6);
          p.style.width = w2 + 'px'; p.style.height = w2 + 'px';
          p.style.borderRadius = '50%';
        } else {                        // paper rectangle
          var w3 = 6 + Math.round(Math.random() * 8);
          p.style.width = w3 + 'px';
          p.style.height = (w3 + 2 + Math.round(Math.random() * 6)) + 'px';
          p.style.borderRadius = '1px';
        }
        return p;
      };
    }
    else if (fx === 'coins') { n = 24; makeEl = function () { var p = document.createElement('span'); p.className = 'u4r-fx-glyph u4r-fx-fall'; p.textContent = '🪙'; return p; }; }
    else if (fx === 'emoji') { n = 18; var em = ['🎉', '🎁', '✨', '⭐']; makeEl = function (i) { var p = document.createElement('span'); p.className = 'u4r-fx-glyph u4r-fx-rise'; p.textContent = em[i % em.length]; return p; }; }
    else if (fx === 'sparkles') { n = 20; makeEl = function () { var p = document.createElement('span'); p.className = 'u4r-fx-glyph u4r-fx-rise'; p.textContent = '✨'; return p; }; }
    else { layer.remove(); return; }
    for (var i = 0; i < n; i++) {
      var p = makeEl(i);
      p.style.left = (Math.random() * 100) + '%';
      if (fx === 'confetti') {
        // premium confetti: per-motion duration + drift, scaled by the merchant speed setting
        p.style.animationDelay = (Math.random() * 0.55) + 's';
        p.style.animationDuration = ((1.7 + Math.random() * 1.5) * motionDurF * confSpeed) + 's';
        p.style.setProperty('--u4r-dx', (((Math.random() * 2) - 1) * motionDxR | 0) + 'px');
        p.style.setProperty('--u4r-sway', ((24 + Math.random() * 46) | 0) + 'px');
        p.style.setProperty('--u4r-spin', ((((Math.random() * 2) - 1) * (360 + Math.random() * 900)) | 0) + 'deg');
        p.style.setProperty('--u4r-flip', ((((Math.random() * 2) - 1) * (360 + Math.random() * 720)) | 0) + 'deg');
        p.style.setProperty('--u4r-fall', ((460 + Math.random() * 260) | 0) + 'px');
      } else {
        p.style.animationDelay = (Math.random() * 0.5) + 's';
        p.style.animationDuration = (1.2 + Math.random() * 1.1) + 's';
        p.style.setProperty('--u4r-rot', ((Math.random() * 360) | 0) + 'deg');
        p.style.setProperty('--u4r-dx', (((Math.random() * 2) - 1) * 75 | 0) + 'px');
      }
      layer.appendChild(p);
    }
    // remove only after the last particle has fully faded (scaled with motion + speed)
    setTimeout(function () { layer.remove(); }, fx === 'confetti' ? Math.round((3.4 * motionDurF * confSpeed + 0.7) * 1000) : 2900);
  }

  function celebrateCrossings(milestones, q) {
    if (!milestones || !milestones.length) return;
    var hasBaseline = sessionStorage.getItem('u4r_reached') !== null;
    var prev = [];
    try { prev = JSON.parse(sessionStorage.getItem('u4r_reached') || '[]'); } catch (e) { prev = []; }
    var now = [];
    milestones.forEach(function (m) { if (q >= m.cents) now.push(m.key); });
    if (hasBaseline) {
      milestones.forEach(function (m) { if (q >= m.cents && prev.indexOf(m.key) === -1) celebrate(m.fx); });
    }
    sessionStorage.setItem('u4r_reached', JSON.stringify(now));
  }

  function revealGifts(keys) {
    if (!keys.length) return;
    getCart().then(function (cart) {
      var lineKeys = (cart.items || [])
        .filter(function (it) { return it.properties && keys.indexOf(it.properties._free_gift) > -1; })
        .map(function (it) { return it.key; });
      setTimeout(function () {
        lineKeys.forEach(function (lk) {
          var row = document.querySelector('.cart-drawer__inner [data-key="' + lk + '"]');
          if (row) { row.classList.add('u4-gift-reveal'); }
        });
      }, 30);
    });
  }

  async function reconcile(el) {
    if (window.__u4RewardsBusy) return;
    var gifts, milestones;
    try { gifts = JSON.parse(el.getAttribute('data-gifts') || '[]'); } catch (e) { gifts = []; }
    try { milestones = JSON.parse(el.getAttribute('data-milestones') || '[]'); } catch (e) { milestones = []; }
    window.__u4RewardsBusy = true;
    try {
      var cart = await getCart();
      var q = qualifying(cart);
      celebrateCrossings(milestones, q);

      var present = {};
      (cart.items || []).forEach(function (it) {
        var k = it.properties && it.properties._free_gift;
        if (k) present[k] = it;
      });

      var toAdd = [], toRemove = [], toFix = [];
      gifts.forEach(function (g) {
        if (!g || !g.variant) return;
        var should = q >= g.cents;
        var line = present[g.key];
        if (should && !line) { if (!window.__u4RewardsFailed[g.key]) toAdd.push(g); }
        else if (!should && line) { toRemove.push(line); }
        else if (should && line && line.quantity > 1) { toFix.push(line); }
      });

      // ORPHAN CLEANUP: a free-gift line whose key is no longer in the active gift config
      // (e.g. the merchant DISABLED that gift) is no longer managed by the loop above. These rows
      // have their remove button hidden, so the shopper cannot clear them — remove them here so a
      // disabled gift actually disappears from the cart on the next open / cart change.
      var __validKeys = {};
      gifts.forEach(function (g) { if (g && g.key) __validKeys[g.key] = true; });
      Object.keys(present).forEach(function (k) {
        if (!__validKeys[k]) toRemove.push(present[k]);
      });

      // how many gift lines SHOULD exist once the cart settles (excludes failed adds) —
      // used both to drive a verified refresh and to detect DOM drift
      var expectedGifts = 0;
      gifts.forEach(function (g) {
        if (g && g.variant && q >= g.cents && !window.__u4RewardsFailed[g.key]) expectedGifts++;
      });

      var didServerChange = false;
      var addedKeys = [];
      var sid = getSid();
      // ask Shopify to return the rendered drawer section IN the mutation response —
      // atomic with the cart change, so NO lag, NO race with the theme, NO rate-limited GET
      var secProps = sid ? { sections: sid, sections_url: location.pathname } : {};
      var lastHtml = null;
      function grabSections(json) {
        if (json && json.sections && sid && json.sections[sid]) lastHtml = json.sections[sid];
      }

      // ---- remove gifts that no longer qualify (CLEAN removal, no pre-removal fade) ----
      // The theme ALSO re-renders the drawer on a native +/- — with the gift still present, since we
      // haven't removed it yet — which wipes any fade-out class and makes the gift appear to "come
      // back" right before vanishing (the glitch the shopper sees). So we just remove it: the section
      // re-render returned with the mutation shows it gone in one clean step.
      if (toRemove.length) {
        for (var i = 0; i < toRemove.length; i++) {
          var rr = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(Object.assign({ id: toRemove[i].key, quantity: 0 }, secProps)) });
          try { grabSections(await rr.json()); } catch (e) {}
          didServerChange = true;
        }
      }

      // keep gift quantity at 1
      for (var f = 0; f < toFix.length; f++) {
        var rf = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(Object.assign({ id: toFix[f].key, quantity: 1 }, secProps)) });
        try { grabSections(await rf.json()); } catch (e) {}
        didServerChange = true;
      }

      // ---- add unlocked gifts ----
      for (var a = 0; a < toAdd.length; a++) {
        var g = toAdd[a];
        var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(Object.assign({ id: g.variant, quantity: 1, properties: { _free_gift: g.key } }, secProps)) });
        if (res.ok) { didServerChange = true; addedKeys.push(g.key); try { grabSections(await res.json()); } catch (e) {} } else { window.__u4RewardsFailed[g.key] = true; expectedGifts = Math.max(0, expectedGifts - 1); }
      }

      // flag a freshly-unlocked gift so the whole section (header + rows) reveals smoothly.
      // In grouped mode the grouping module animates header+rows together; otherwise we animate the row here.
      if (addedKeys.length) { window.__u4GiftReveal = true; }
      var grouped = !!document.querySelector('.cart-items[data-u4-group="true"]');
      if (lastHtml) {
        // authoritative render straight from the mutation response — apply once, no flicker
        applySectionHtml(lastHtml);
        if (!grouped) revealGifts(addedKeys);
      } else {
        // no cart change (or response lacked sections) — only refresh if the DOM has drifted
        // from the desired gift state (e.g. a late theme re-render dropped our gift)
        var domGifts = document.querySelectorAll('.cart-drawer__inner .cart-items__table-row--free-gift').length;
        if (domGifts !== expectedGifts) {
          var html = await fetchSectionOnce(sid, expectedGifts);
          if (html) { applySectionHtml(html); if (!grouped) revealGifts(addedKeys); }
        }
      }
    } catch (e) { /* noop */ }
    finally {
      window.__u4RewardsBusy = false;
      // cooldown ONLY after a real server change — a no-op reconcile must not block the
      // next sync (that was causing a multi-second cascade of delayed gift appearance)
      if (didServerChange) {
        window.__u4Cooldown = (window.performance ? performance.now() : Date.now()) + 1200;
      }
    }
  }

  class CartRewards extends HTMLElement {
    connectedCallback() {
      var self = this;
      this._t = setTimeout(function () { reconcile(self); }, 40);
    }
    disconnectedCallback() { if (this._t) clearTimeout(this._t); }
  }
  if (!customElements.get('cart-rewards')) { customElements.define('cart-rewards', CartRewards); }

  /* Standalone orphan sweep: if the rewards bar is fully disabled (no <cart-rewards> element on the
     page at all), reconcile never runs — yet a previously auto-added free gift can still be stuck in
     the cart with no remove button. Sweep those out directly. */
  async function orphanSweep() {
    if (window.__u4RewardsBusy) return;
    if (document.querySelector('cart-rewards')) return; // managed by reconcile()
    try {
      var cart = await getCart();
      var orphans = (cart.items || []).filter(function (it) { return it.properties && it.properties._free_gift; });
      if (!orphans.length) return;
      window.__u4RewardsBusy = true;
      var sid = getSid();
      var secProps = sid ? { sections: sid, sections_url: location.pathname } : {};
      var lastHtml = null;
      for (var i = 0; i < orphans.length; i++) {
        var rr = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(Object.assign({ id: orphans[i].key, quantity: 0 }, secProps)) });
        try { var j = await rr.json(); if (j && j.sections && sid && j.sections[sid]) lastHtml = j.sections[sid]; } catch (e) {}
      }
      if (lastHtml) applySectionHtml(lastHtml);
    } catch (e) { /* noop */ }
    finally { window.__u4RewardsBusy = false; }
  }

  /* Re-sync gifts when the cart drawer is morphed by native +/- buttons. */
  if (!window.__u4RewardsObserver) {
    window.__u4RewardsObserver = true;
    var __u4SyncTimer = null;
    function now() { return window.performance ? performance.now() : Date.now(); }
    function triggerSync() {
      if (window.__u4RewardsBusy) return;
      if (now() < (window.__u4Cooldown || 0)) return; // skip churn from our own re-render/grouping
      clearTimeout(__u4SyncTimer);
      __u4SyncTimer = setTimeout(function () {
        var el = document.querySelector('cart-rewards');
        if (el) reconcile(el); else orphanSweep();
      }, 60);
    }
    // a mutation is "real" (cart changed) if it adds/removes an actual element that is NOT one of our own group headers
    function isRealCartMutation(muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type !== 'childList') continue;
        var nodes = [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes));
        for (var j = 0; j < nodes.length; j++) {
          var nd = nodes[j];
          if (nd.nodeType === 1 && !(nd.classList && nd.classList.contains('u4-grp-header'))) return true;
        }
      }
      return false;
    }
    function attachObs() {
      // observe the STABLE custom element; the theme replaces .cart-drawer__inner wholesale on every qty change
      var host = document.querySelector('cart-drawer-component') || document.querySelector('.cart-drawer');
      if (host && !host.__u4obs) {
        host.__u4obs = true;
        new MutationObserver(function (muts) {
          if (window.__u4RewardsBusy) return;
          if (isRealCartMutation(muts)) triggerSync();
        }).observe(host, { childList: true, subtree: true });
      }
    }
    if (document.readyState !== 'loading') attachObs(); else document.addEventListener('DOMContentLoaded', attachObs);
    setTimeout(attachObs, 1200);
    // one orphan sweep shortly after load in case rewards is fully disabled
    setTimeout(function () { if (!document.querySelector('cart-rewards')) orphanSweep(); }, 1500);
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) { document.addEventListener(ev, triggerSync); });

    /* Proactive sync: fire reconcile on a ladder after +/- clicks so we don't
       wait for the theme's slow drawer morph. First slot that runs after the
       server commits does the work; later slots are blocked by cooldown or busy. */
    function fastReconcile() {
      [700, 1800, 3000].forEach(function (d) {
        setTimeout(function () {
          if (window.__u4RewardsBusy) return;
          if (now() < (window.__u4Cooldown || 0)) return; // respect cooldown — no duplicate runs
          var el = document.querySelector('cart-rewards');
          if (el) reconcile(el);
        }, d);
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('button[name="plus"], button[name="minus"], .cart-items__remove');
      if (b) fastReconcile();
    }, true);
  }
})();
